import type { AxiosInstance } from 'axios';
import { sendContactRequest } from './apiContactRequest';
import { getVacancy, getVacancies } from './apiVacancies';
import { sendApplication, getApplicationPresignedUrlsData, s3UploadFile } from './apiApplication';

export default function initApiAws(apiInstance: AxiosInstance) {
  return {
    sendContactRequest: (params: any) => sendContactRequest(apiInstance, params),
    getVacancies: (language: string) => getVacancies(apiInstance, language),
    getVacancy: (id: string, language: string) => getVacancy(apiInstance, id, language),
    sendApplication: (params: any) => sendApplication(apiInstance, params),
    getApplicationPresignedUrlsData: (fileNames: string[]) => getApplicationPresignedUrlsData(apiInstance, fileNames),
    s3UploadFile: (fileUpload: any) => s3UploadFile(apiInstance, fileUpload),
  };
}

export type ApiAws = ReturnType<typeof initApiAws>;
